import { AnimatePresence, MotiView } from 'moti'
import React from 'react'
import { Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/SvgIcon'

import { sectionCircleStyles } from './styles'

interface SectionCircleProps {
  sectionNumber: number
  state: 'completed' | 'active' | 'future'
}

const checkmarkIcon = IMAGE.icons.xsmall.checkmarkWhite_14x11
const checkmarkIconSrc = checkmarkIcon.default?.src ?? checkmarkIcon

const crossfadeTransition = {
  opacity: { type: 'timing' as const, duration: 150 },
  scale: { type: 'timing' as const, duration: 150 },
}

const crossfadeProps = {
  from: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
  transition: crossfadeTransition,
} as const

const SectionCircle = (props: SectionCircleProps) => {
  const { circle, number, checkIcon } = sectionCircleStyles({ state: props.state })
  const isCompleted = props.state === 'completed'

  return (
    <View key={props.state} className={circle()}>
      <AnimatePresence initial={false}>
        {isCompleted ? (
          <MotiView key="check" className={checkIcon()} {...crossfadeProps}>
            <Icon imgSrc={checkmarkIconSrc} size={14} />
          </MotiView>
        ) : (
          <MotiView key="number" {...crossfadeProps}>
            <Text className={number()}>{props.sectionNumber}</Text>
          </MotiView>
        )}
      </AnimatePresence>
    </View>
  )
}

export default SectionCircle
